import React, { Fragment, useContext, useState, useEffect } from "react";
import Menu from "./components/Menu";
import SingleImage from "./components/SingleImage";
import Damage from "./components/Damage";
import Video from "./components/Video";
import MultipleImage from "./components/MultipleImage";
import Loading from "./components/Loading";
import Instructions from "./components/Instructions";
import Email from "./components/Email";
import Restart from "./components/Restart";
import Navbar from "./components/Navbar";
import { AppContext } from "./context";
import { useAppData } from "./context/hooks";
import { stopSessionTimeoutTimer } from "./context/utils";
import Success from "./components/Success";
import QR from "./components/QR";
import Error from "./components/Error";
import Zeroapp from "./components/Zeroapp";
import WindshieldDamge from "./components/WindshieldDamge";
import Form from "./components/Form";
import Ping from "./components/Ping";
import NewVideo from "./components/NewVideo";
import MultipleImageSub from "./components/wondlePortraitApp/MultipleImageSub.js";
import NewZIZO from "./components/NewZIZO.js";
import * as Sentry from "@sentry/react";
// import ReactGA from "react-ga4";
import Rejection from "./components/Rejection";
import SelfieModule from "./components/SelfieModule";
import VideoRecorder from "./components/VideoRecorder";
import FormModule from "./components/FormModule";
import CustomHiibModule from "./components/CustomHiibModule";
import TimeOut from "./components/TimeOut";
import ImageUpload from "./components/ImageUpload";
import WondleMultipleImage from "./components/wondlePortraitApp/WondleMultipleImage.js";
import WondleSingleImage from "./components/wondlePortraitApp/WondleSingleImage.js";
import FormModuleWondle from "./components/wondlePortraitApp/FormModuleWondle.js";
import SuccessPort from "./components/wondlePortraitApp/SuccessPort.js";
import Email_holiday from "./components/Email_holiday.js";
import BikeStencils from "./components/BikeStencil.js";
import StencilVideo from "./components/StencilVideo.js";
import NewImgApp from "./components/NewImgApp.js";
import MenuOpes from "./components/opesApp/MenuOpes.js";
import Image360Feedback from "./components/opesApp/Image360Feedback.js";
import KarlQuestion from "./components/KarlCustom.js";
import New360ImgFeedback from "./components/New360ImgFeedback.js";
import Liberty from "./components/Liberty.js";
import IntegratedVideo from "./components/IntegratedVideo.js";
import KotakFormPage from "./components/kotakFormPage.js";
import LibertyDocument from "./components/LibertyDocument.js";
import NewCustomDocumentUpload from "./components/NewDocumentUpload.js";
import DigileraDocumentUpload from "./components/DigileraDocumentUpload.js";
import CarlFrontQuestion from "./components/CarlFrontQuestion.js";

function App() {
  const appData = useAppData();
  const { config } = useContext(AppContext);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      console.log("handle event listner");
      setSessionExpired(true);
    };
    window.addEventListener("session_expired", handleSessionExpired);
    return () => {
      console.log("assign event listner");
      window.removeEventListener("session_expired", handleSessionExpired);
    };
  }, []);

  useEffect(() => {
    if (appData.screen === "success" || appData.screen === "port-success") {
      console.log("suiccess reched timer end");
      stopSessionTimeoutTimer();
    }
  }, [appData.screen]);

  return (
    <AppContext.Provider value={appData}>
      <Fragment>
        <>
          {appData.screen === "loading" ? (
            <Loading />
          ) : appData.screen === "error" ? (
            <Error />
          ) : appData.screen === "rejection" ? (
            <div>
              <Navbar />
              <Rejection />
            </div>
          ) : appData.screen === "form" ? (
            <div>
              <Navbar />
              <Form />
            </div>
          ) : appData.screen === "email" ? (
            <Email />
          ) : appData.screen === "KarlQuestion" ? (
            <KarlQuestion />
          ) : appData.screen === "carlFrontQuestion" ? (
            <CarlFrontQuestion />
          ) : appData.screen === "Liberty" ? (
            <Liberty />
          ) : appData.screen === "VehicleInfo" ? (
            <KotakFormPage />
          ) : appData.screen === "email_holiday" ? (
            <Email_holiday />
          ) : appData.screen === "restart" ? (
            <Restart />
          ) : appData.screen === "instructions" ? (
            <div>
              <Instructions />
            </div>
          ) : appData.screen === "menuOpes" ? (
            <MenuOpes />
          ) : appData.screen === "menu" ? (
            <Menu />
          ) : appData.screen === "block" ? (
            <SelectPage />
          ) : appData.screen === "success" ? (
            <Success />
          ) : appData.screen === "port-success" ? (
            <SuccessPort />
          ) : appData.screen === "timeOut" ? (
            <TimeOut />
          ) : (
            <SelectPage />
          )}
          {appData.screen !== "loading" && <Ping />}

          {sessionExpired && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(10, 10, 10, 0.85)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 999999,
              }}
            >
              <div
                style={{
                  // background: "linear-gradient(135deg, #1e1e1e 0%, #121212 100%)",
                  backgroundColor: "white",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "16px",
                  padding: "40px 30px",
                  maxWidth: "450px",
                  width: "90%",
                  textAlign: "center",
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.5)",
                  // color: "#ffffff",
                  color: "black",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(220, 53, 69, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px auto",
                    border: "1px solid rgba(220, 53, 69, 0.3)",
                  }}
                >
                  <span style={{ fontSize: "30px", color: "#dc3545" }}>⚠️</span>
                </div>
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "15px",
                    letterSpacing: "-0.5px",
                  }}
                >
                  {Object.keys(config).includes("sessionExpireHeaderText")
                    ? config["sessionExpireHeaderText"]
                    : "Session Expired"}
                </h2>
                {/* <p style={{ fontSize: "15px", color: "#a0a0a0", marginBottom: "30px", lineHeight: "1.6" }}> */}
                <p
                  style={{
                    fontSize: "15px",
                    color: "black",
                    marginBottom: "30px",
                    lineHeight: "1.6",
                  }}
                >
                  {Object.keys(config).includes("sessionExpireText")
                    ? config["sessionExpireText"]
                    : "It has been more than 10 minutes since your last image upload. Your session has expired. Please contact your administrator to obtain a new inspection link."}
                </p>
                {/* <button
                  onClick={() => window.location.reload()}
                  style={{
                    width: "100%",
                    padding: "14px",
                    fontSize: "16px",
                    fontWeight: "600",
                    backgroundColor:
                      config["colors"] && config["colors"]["btn"]
                        ? config["colors"]["btn"]
                        : "#006cc9",
                    color: "white",
                    // backgroundColor: "#dc3545",
                    // color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: `0 4px 12px ${config["colors"] && config["colors"]["btn"]
                      ? config["colors"]["btn"]
                      : "#006cc9"}`,
                  }}
                >
                  Restart Application
                </button> */}
              </div>
            </div>
          )}
        </>
      </Fragment>
    </AppContext.Provider>
  );
}

const SelectPage = () => {
  const { currentBlock, clientId } = useContext(AppContext);
  switch (currentBlock.name) {
    case "DigileraDocumentUpload":
      return <DigileraDocumentUpload />;
    case "Liberty Document":
      return <LibertyDocument />;
    case "Custom Document Upload":
      return <NewCustomDocumentUpload />;
    case "opes 360 Image":
      return <Image360Feedback />;
    case "Stencil Video":
      return <StencilVideo />;
    case "New ZIZO Capture":
      return <NewZIZO />;
    case "damage":
      return <Damage />;
    case "360 Wondle Image":
      return <WondleMultipleImage />;
    case "Video Capture":
      return <Video />;
    case "QR":
      return <QR />;
    case "New Video Capture":
      return <NewVideo />;
    case "VinOdo Video Capture":
      return <IntegratedVideo />;
    // [
    //   "client_1298_prod",
    //   "client_1298_dev",
    //   "client_1298",
    //   "client_1511",
    //   "porto_seguros_uat",
    //   "porto_seguros_claim",
    //   "porto_seguros",
    //   "client_1282",
    //   "client_1381_demo",
    //   "client_1381",
    //   "client_1381_prod",
    // ].includes(clientId) ? (
    //   <NewVideo />
    // ) : (
    //   <StencilVideo />
    // );
    case "Bike Stencil":
      return <BikeStencils />;
    case "New Image App":
      return <NewImgApp />;
    case "zeroapp":
      return <Zeroapp />;
    case "Windshield Damage":
      return <WindshieldDamge />;
    case "Selfie":
      return <SelfieModule />;
    case "Video Recorder":
      return <VideoRecorder />;
    case "Form Module":
      return <FormModule />;
    case "Form Module Portrait":
      return <FormModuleWondle />;
    case "Custom Hiib Module":
      return <CustomHiibModule />;
    case "ImageUpload":
      return <ImageUpload />;
    default:
      switch (currentBlock.subSections) {
        case true:
          switch (currentBlock.subSectionsSub) {
            case true:
              return <MultipleImageSub />;
            default:
              switch (currentBlock.fallBackBlock) {
                case true:
                  return <New360ImgFeedback />;
                default:
                  return <MultipleImage />;
              }
          }
        case false:
          if (currentBlock.subSectionsSub) {
            return <WondleSingleImage />;
          }
          return <SingleImage />;
        default:
          return <></>;
      }
  }
};

export default Sentry.withProfiler(App);
